<h2 mat-dialog-title>Server Status</h2>
<mat-dialog-content>
  <div *ngFor="let key of objectKeys(status)">{{key + ' : ' + status[key]}}</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>